import { Modules } from './Modules';

class StartUp {
    constructor() {
        new Modules();
    }
}

export { StartUp }